export default __webpack_public_path__ + "static/media/14.81e827a7.png";